import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HomesliderServices from '../services/HomeSliderServices';
import useAsync from '../hooks/useAsync';
import SelectSliderSequence from './TogelButton/SelectSliderSequence';
import HelpTogal from './TogelButton/HelpTogal';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import HomeSliderUpdate from './Update Model/HomeSliderUpdate';
import * as XLSX from 'xlsx';

Modal.setAppElement('#root');

function HomeSlider() {
  const { data, error, isLoading, run } = useAsync(HomesliderServices.getHomeSlider);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const handleEditDetails = (slider) => {
    setSelectedEdit(slider);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (slider) => {
    setSelectedEdit(slider);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };


  // Filtered data based on search query
  const filteredData = data?.data?.filter(slider =>
    slider.title.toLowerCase().includes(searchQuery.toLowerCase().trim())
  );


  const generateExcel = () => {
    const filteredData = data?.data?.map(slider => ({
      title: slider?.title,
      image: process.env.REACT_APP_URL + slider?.image,
      sequence: slider?.sequence,
      date: formatDateTime(slider?.createdAt),
      status: slider?.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'HomeSliderData');
    XLSX.writeFile(wb, 'home_slider_data.xlsx');
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Home Slider Banner List <span className="badge bg-orange">{filteredData?.length || 0}</span>             </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Home Slider Banner
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <Link className="round-add-btn" to="/add-home-slider">
              <img src="img/plus.svg" alt="Add Slider" />
            </Link>
            <button className="excel-btn" onClick={generateExcel}>
              <img src="img/excel.svg" alt="Download Excel" />
              Download
            </button>

          </div>
        </div>

        <div className="container-box px-0 pt-2">
          <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search By Name"
                    className='form-control'
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>

          </div>

          <div className="container-box-inner table-reponsive-tabe">
            <table id="example" className="table table-striped" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>TITLE</th>
                  <th>IMAGE</th>
                  <th>DATE</th>
                  <th>SEQUENCE</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {filteredData?.map((slider, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{slider?.title}</td>
                    <td>
                      <div className="product-img">
                        <img
                          src={process.env.REACT_APP_URL + slider?.image}
                          alt=""
                          style={{ height: '70px', width: '70px', objectFit: 'contain' }}
                        />
                      </div>
                    </td>
                    <td>{formatDateTime(slider?.createdAt)}</td>
                    <td>
                      <SelectSliderSequence data={slider} onSuccess={() => run()} />
                    </td>
                    <td className="status-toggle">
                      <HelpTogal help={slider} page="HomeSlider" onSuccess={() => run()} />
                    </td>
                    <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === i && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="edit" onClick={() => handleEditDetails(slider)}>Edit</button>
                              </li>
                              <li>
                                <button className="reject" onClick={() => handleDelete(slider)}>Delete</button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <HomeSliderUpdate slider={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="HomeSlider" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
      </div>
    </>
  );
}

export default HomeSlider;
